@if (config.description) {
  <div
    class="form-group-array__description"
    data-test-id="formGroupArrayDescription"
  >
    {{ config.description }}
  </div>
}

@for (arrayGroup of formArray.controls; track arrayGroup; let i = $index) {
  <zip-card [attr.data-test-id]="'formGroupArrayCard_' + i">
    <ng-container [attr.data-test-id]="'formGroupArrayCardTitle_' + i" title>
      {{ config.title }} {{ !config?.hideTitleCount ? i + 1 : '' }}
    </ng-container>
    <ng-container
      [attr.data-test-id]="'formGroupArrayCardHeader_' + i"
      header-action
    >
      @if (formArray?.length > 1 && !(i === 0 && config.protectMain)) {
        <zip-button
          (keydown.enter)="removeGroup(i)"
          [config]="{
            level: 'text',
            icon: 'close',
          }"
          (zipButtonClicked)="removeGroup(i)"
          [attr.data-test-id]="'formGroupArrayCardRemoveGroupButton_' + i"
        >
        </zip-button>
      }
    </ng-container>
    <ng-container
      [attr.data-test-id]="'formGroupArrayCardBody_' + i"
      body-group
    >
      <div
        [formGroup]="arrayGroup"
        [attr.data-test-id]="'formGroupArrayWrapper_' + i"
      >
        <form-group
          [attr.data-test-id]="'formGroupArray_' + i"
          [configs]="config.controls"
          [form]="arrayGroup"
        >
        </form-group>
      </div>
    </ng-container>
  </zip-card>
}

<div class="form-group-array__footer" data-test-id="formGroupArrayFooter">
  @if (!(config?.maxLength === formArray?.length)) {
    <zip-button
      level="medium"
      icon="add"
      (zipButtonClicked)="addGroup()"
      [content]="config.addButtonText"
      data-test-id="formGroupArrayFooterAddGroupButton"
    >
    </zip-button>
  }
</div>
